import { render } from "./MovieCreateView.vue?vue&type=template&id=6cbccc92"
import script from "./MovieCreateView.vue?vue&type=script&lang=js"
export * from "./MovieCreateView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__